import React from "react";
import { useUserContext } from "context/UserContext";
import TransactionsBK from "layouts/BK/transactions";
import TransactionsSP from "layouts/SP/transactions";
import TransactionsCM from "layouts/CM/transactions";
import { isBkLikeRole } from "utils/roleUtils";

function Transactions() {
  const { role } = useUserContext() || {};
  if (role === "SP") {
    return <TransactionsSP />;
  }
  if (isBkLikeRole(role)) {
    return <TransactionsBK />;
  }
  if (role === "CM") {
    return <TransactionsCM />;
  }
  return null;
}

export default Transactions;
